import { CreateAgencyDto, DeleteAgencyDto, IAgency, UpdateAgencyDto } from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';
import { UpdateAgencySettingsDto } from 'admiral-core/dist/dtos/agency/update-agency-settings.dto';

export class AgencyApi {
  static getAgency(): Promise<AxiosResponse<IAgency>> {
    return AdmiralApi.apiCall<IAgency>({
      method: 'POST',
      url: `${BASE_URL}/agency/id`,
    });
  }

  static create(createAgencyDto: CreateAgencyDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall({
      method: 'PUT',
      url: `${BASE_URL}/agency`,
      data: createAgencyDto,
    });
  }

  static update(id: string, updateAgencyDto: UpdateAgencyDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall({
      method: 'PATCH',
      url: `${BASE_URL}/agency/${id}`,
      data: updateAgencyDto,
    });
  }

  static updateSettings(id: string, dto: UpdateAgencySettingsDto): Promise<AxiosResponse<IAgency>> {
    return AdmiralApi.apiCall<IAgency>({
      method: 'PATCH',
      url: `${BASE_URL}/agency/${id}/settings`,
      data: dto,
    });
  }

  static delete(id: string, deleteAgencyDto: DeleteAgencyDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall({
      method: 'DELETE',
      url: `${BASE_URL}/agency/${id}`,
      data: deleteAgencyDto,
    });
  }
}
